"use client"; // Ensures this is a Client Component
import React from "react";
import { Button } from "react-bootstrap";
import Image, { StaticImageData } from 'next/image'; 
import Link from "next/link";

interface MoveTemokProps {
  title: string;
  description: string;
  subtitle: string;
  buttonText: string;
  imageSrc: StaticImageData;
  onButtonClick?: () => void; // Event handler for button clicks
}

const MoveTemok: React.FC<MoveTemokProps> = ({
  title,
  description,
  subtitle,
  buttonText,
  imageSrc,
  onButtonClick,
}) => {
  const slug_link = "dedicated-servers-usa";
  return (
    <div className="custMargin">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 col-md-12 col-12">
            <div className="bnrSlogan">
              <h3 className="textHad display-6 fw-bold">{title}</h3>
              <p className="textPara fs-5 fw-normal">{description}</p>
              <h4 className="textHad fs-4 display-6 fw-bold">{subtitle}</h4>
              <div className="mt-3">
                <Link href={slug_link}>
                  <Button variant="primary" size="lg" onClick={onButtonClick}  className='button'>
                    <span>  {buttonText} </span>
                  </Button>
                </Link>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-12">
            <div className="bnrLoc">
              <Image
                src={imageSrc}
                width={500}
                height={500}
                className="img-fluid"
                alt="..."
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MoveTemok;
